import { mods } from '@approvalmax/theme';
import { DateTimeEditor } from '@approvalmax/ui';
import { StyledMods } from '@styled-kit/mods';
import { PriceCheckIndicator, WarningLevel } from 'modules/request';
import { font, uTextEllipsis } from 'modules/styles';
import styled from 'styled-components';

import { SectionContainer } from '../../../components/SectionContainer';
import { QBooksLineItemCustomerCell } from '../QBooksLineItemCustomerCell/QBooksLineItemCustomerCell';
import { QbooksLineItemDropdownCell } from '../QbooksLineItemDropdownCell/QbooksLineItemDropdownCell';
import { QbooksLineItemItemCell } from '../QBooksLineItemItemCell/QbooksLineItemItemCell';

export const Root = styled(SectionContainer)`
    margin-bottom: 30px;
`;

export const Header = styled.div`
    padding: 0 60px;
    display: flex;
    align-items: center;
    position: relative;
`;

export const HeaderFields = styled.div`
    flex: 1;
    display: flex;
    justify-content: flex-end;
    text-transform: none;
`;

export const HeaderFieldsLabel = styled.div`
    padding: 5px 10px 0 30px;
    ${font(12, '#a0a1a1', 'standard')}
`;

export const HeaderFieldsLineAmountTypeContainer = styled.div`
    width: 120px;
`;

export const Content = styled.div`
    display: flex;
    flex-flow: column;
`;

export const QbooksLineItemItemCellStyled = styled(QbooksLineItemItemCell)`
    margin: -3px;
`;

export const QbooksLineItemDropdownCellStyled = styled(QbooksLineItemDropdownCell)`
    margin: -3px;
`;

export const QBooksLineItemCustomerCellStyled = styled(QBooksLineItemCustomerCell)`
    margin: -3px;
`;

export const AmountCell = styled.div`
    ${uTextEllipsis}
`;

export const BillableCheckbox = styled.div`
    display: flex;
    justify-content: center;
`;

export const TaxableCheckbox = styled.div`
    display: flex;
    justify-content: center;
`;

export const ServiceDateCell = styled(DateTimeEditor)`
    margin: -3px;

    input,
    input:focus {
        border: none;
    }
`;

export const Linked = styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const PriceIndicator = styled.div<StyledMods<{ warningLevel: WarningLevel }>>`
    position: absolute;
    right: 0;
    top: 50%;
    width: 5px;
    height: calc(100% - 10px);
    transform: translateY(-50%);

    ${mods('warningLevel', WarningLevel.Yellow)`
        background: #ffe688;
    `}
    ${mods('warningLevel', WarningLevel.Orange)`
        background: #f0984f;
    `}

    ${mods('warningLevel', WarningLevel.Red)`
        background: #cb4e30;
    `}

    ${mods('warningLevel', WarningLevel.Black)`
        background: #000;
    `}
`;

export const StyledPriceCheckIndicator = styled(PriceCheckIndicator)`
    && {
        position: relative;
        width: calc(100% + 20px);
        height: calc(100% + 30px);
        margin: -15px -10px;
        padding: 15px 10px;
    }
`;

export const GroupActions = styled.div`
    position: absolute;
    background: #fff;
    display: flex;
    align-items: flex-end;
    gap: 20px;
`;
